<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="overview-wrap">
                    <h2 class="title-1">Дизайн</h2>
                </div>
            </div>
        </div>

        <div class="row my-3">
            <div class="card w-100">
                <div class="card-header">
                    <p>Background color</p>
                </div>
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-3">
                            <label for="text-input" class="form-control-label"
                                >Зүүн өнгө</label
                            >
                        </div>
                        <div class="col-9">
                            <div
                                id="cp1"
                                class="input-group"
                                title="Using format option"
                            >
                                <input
                                    type="text"
                                    class="form-control input-lg"
                                    value="#305AA2"
                                    v-on:input="
                                        onChangeHandler('left', $v.left)
                                    "
                                    :class="{
                                        'form-control is-invalid':
                                            $v.left.$error,
                                    }"
                                    v-model="left"
                                />
                                <span class="input-group-append">
                                    <span
                                        class="input-group-text colorpicker-input-addon"
                                    >
                                        <i></i>
                                    </span>
                                </span>
                                <div class="invalid-feedback">
                                    {{ this.getErrorMsg("left")[0] }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-3">
                            <label for="text-input" class="form-control-label"
                                >Баруун өнгө</label
                            >
                        </div>
                        <div class="col-9">
                            <div
                                id="cp2"
                                class="input-group"
                                title="Using format option"
                            >
                                <input
                                    type="text"
                                    class="form-control input-lg"
                                    value="#305AA1"
                                    v-on:input="
                                        onChangeHandler('right', $v.right)
                                    "
                                    :class="{
                                        'form-control is-invalid':
                                            $v.right.$error,
                                    }"
                                    v-model="right"
                                />
                                <span class="input-group-append">
                                    <span
                                        class="input-group-text colorpicker-input-addon"
                                    >
                                        <i></i>
                                    </span>
                                </span>
                                <div class="invalid-feedback">
                                    {{ this.getErrorMsg("right")[0] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer d-flex justify-content-end">
                    <div
                        v-if="isAdmin"
                        class="card-footer d-flex justify-content-end"
                    >
                        <button
                            @click="setBg"
                            type="button"
                            class="btn btn-success mx-2"
                        >
                            <i class="fa fa-dot-circle-o"></i> Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-3">
            <div class="card w-100">
                <div class="card-header d-flex justify-content-between">
                    <p>Homepage slider</p>
                    <button
                        v-if="isAdmin"
                        @click="imageOpenDialog('image-input-home-slider')"
                        class="btn btn-primary"
                    >
                        <i class="fas fa-plus"></i>
                    </button>
                    <input
                        type="file"
                        accept="image/*"
                        id="image-input-home-slider"
                        class="btn btn-primary"
                        @change="onImageInput($event, true)"
                        hidden
                    />
                </div>

                <div
                    v-if="imageshs.length > 0 || true"
                    class="card-body d-flex flex-row flex-wrap"
                >
                    <div
                        v-for="(image, i) in imageshs"
                        :key="i"
                        class="card justify-content-start mx-1 mb-1"
                    >
                        <div class="card-body height-150">
                            <img
                                v-bind:src="image.src"
                                class="img-thumbnail mh-100"
                                alt
                            />
                        </div>
                        <div v-if="isAdmin" class="card-footer">
                            <input
                                placeholder="Холбоос"
                                @change="updateLink($event, i)"
                                :value="image.link"
                            />
                            <br />
                            <div
                                @click="removeImg(i, true)"
                                class="btn btn-danger btn-sm m-t-10"
                            >
                                <i class="fas fa-trash"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <font
                        v-if="$v.imageshs.$error"
                        size="2"
                        class="text-danger"
                        >{{ this.getErrorMsg("imageshs.1")[0] }}</font
                    >
                </div>

                <div
                    v-if="isAdmin"
                    class="card-footer d-flex justify-content-end"
                >
                    <div class="card-footer d-flex justify-content-end">
                        <button
                            @click="setHs"
                            type="button"
                            class="btn btn-success mx-2"
                        >
                            <i class="fa fa-dot-circle-o"></i> Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <PopupCard language="popup_mon" />
        <PopupCard language="popup_eng" />
    </div>
</template>

<script>
import DesignService from "@/services/DesignService";
import ImageUploadService from "@/services/ImageUploadService";
import PopupCard from "../components/PopupCard.vue";

export default {
    name: "Design",
    created() {
        this.$store.dispatch("setLoading", true);
        this.getDesign();
    },
    computed: {
        isAdmin: function() {
            return this.$store.getters.loggedAdmin.role == 1;
        },
    },
    data() {
        return {
            serverErrors: [],
            design: {},
            imageshs: [],
            right: "",
            left: "",
        };
    },
    validations: {
        imageshs: {
            serverFailed: function() {
                return !this.hasServerError("slide_images");
            },
        },
        left: {
            serverFailed: function() {
                return !this.hasServerError("left");
            },
        },
        right: {
            serverFailed: function() {
                return !this.hasServerError("right");
            },
        },
    },
    methods: {
        getDesign() {
            DesignService.getDesign({})
                .then((response) => {
                    if (response.status == 200 && response.data.success == true)
                        this.design = response.data.payload;
                    this.showToast(response.data.payload.toast);
                    response.data.payload.forEach((value) => {
                        if (value.name == "bg_color") {
                            this.left = JSON.parse(value.value)[0];
                            this.right = JSON.parse(value.value)[1];
                        }
                        if (value.name == "slide_images") {
                            this.imageshs = JSON.parse(value.value);
                        }
                    });
                    this.$store.dispatch("setLoading", false);
                })
                .catch((error) => {
                    this.showToast(error);
                    this.$store.dispatch("setLoading", false);
                });
        },
        setHs() {
            DesignService.setHsDesign({}, this.imageshs)
                .then((response) => {
                    if (
                        response.status == 200 &&
                        response.data.success == true
                    ) {
                        this.showToast(response.data.payload.toast);
                        this.$store.dispatch("setLoading", false);
                    }
                    this.$store.dispatch("setLoading", false);
                })
                .catch((error) => {
                    this.showToast(error.response.data.payload.toast);
                    this.$store.dispatch("setLoading", false);
                });
        },
        setBg() {
            this.$store.dispatch("setLoading", true);
            DesignService.setBgDesign(
                {},
                { left: this.left, right: this.right }
            )
                .then((response) => {
                    if (
                        response.status == 200 &&
                        response.data.success == true
                    ) {
                        this.showToast(response.data.payload.toast);
                        this.$store.dispatch("setLoading", false);
                    }
                    this.$store.dispatch("setLoading", false);
                })
                .catch((error) => {
                    this.showToast(error);
                    this.$store.dispatch("setLoading", false);
                    this.serverErrors = error.response.data.payload.errors;
                    this.$v.$touch();
                });
        },
        getErrorMsg(errorKey) {
            let errors = this.serverErrors.filter(
                (error) => error.name === errorKey
            );
            return errors.map((error) => error.message);
        },
        hasServerError(errorKey) {
            return (
                this.serverErrors.length > 0 &&
                this.serverErrors.filter((error) => error.name === errorKey)
                    .length > 0
            );
        },
        onChangeHandler(errorKey, vModel) {
            if (this.hasServerError(errorKey)) {
                this.serverErrors = this.serverErrors.filter(
                    (error) => error.name !== errorKey
                );
                vModel.$touch();
            }
        },
        onImageInput(event) {
            if (event.target.files[0] != null) {
                this.$store.dispatch("setLoading", true);
                const data = new FormData();
                data.append("image", event.target.files[0]);
                ImageUploadService.uploadImage(data)
                    .then((response) => {
                        this.imageshs[response.data] = {
                            src: response.data,
                            link: "",
                        };
                        this.$store.dispatch("setLoading", false);
                        this.$forceUpdate();
                    })
                    .catch((error) => {
                        this.showToast(error);
                        this.$store.dispatch("setLoading", false);
                    });
            }
        },
        imageOpenDialog(elementid) {
            document.getElementById(elementid).click();
        },
        removeImg(kkk) {
            this.$store.dispatch("setLoading", true);
            delete this.imageshs[kkk];
            this.$store.dispatch("setLoading", false);
            this.$forceUpdate();
            // this.imageshs["a"] = null;
            // let index = this.imageshs.indexOf(image);
            // if (index > -1) this.imageshs.splice(index, 1);
        },
        updateLink(event, kkk) {
            this.imageshs[kkk].link = event.target.value;
        },
    },
    components: { PopupCard },
};
</script>
